import { render, staticRenderFns } from "./CourseUserList.html?vue&type=template&id=67cd19b2&scoped=true&external"
import script from "./CourseUserList.vue?vue&type=script&lang=js"
export * from "./CourseUserList.vue?vue&type=script&lang=js"
import style0 from "./CourseUserList.scss?vue&type=style&index=0&id=67cd19b2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cd19b2",
  null
  
)

export default component.exports